import { render, staticRenderFns } from "./Roadlog.vue?vue&type=template&id=de8b39b0&scoped=true&"
import script from "./Roadlog.vue?vue&type=script&lang=js&"
export * from "./Roadlog.vue?vue&type=script&lang=js&"
import style0 from "./Roadlog.vue?vue&type=style&index=0&id=de8b39b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8b39b0",
  null
  
)

export default component.exports